import Feed from 'containers/feed';
import { useUrlQuery } from 'hooks/useUrlQuery';
import { useLocation } from 'react-router-dom';

export const SearchStylePage = () => {
    const query = useUrlQuery();
    const location: any = useLocation();
    return (
        <Feed
            isSearch
            searchKey={query.get('search') as string}
            stylistName={query.get('stylistName') as string}
            title={location?.state?.title || ''}
        />
    );
};
